export const APP_INFO = {
  appName: "Formax Pay",
  companyName: "Formax It Solutions Private Limited",
  address:
    "N0060N, Mochpole, Nabapally, Barasat, North 24 Parganas, Kolkata - 700126, West Bengal, India",
  phone: "+91 7890090500",
  whatsappNumber: "+91 7890090500",
  whatsappNumberRedirect: "917890090500",
  email: "support@formaxpay.in",
  grievanceEmail: "support@formaxpay.in",
  domainName: "formaxpay.in",
  websiteUrl: "https://formaxpay.in",
  appDownloadUrl: "",
  facebookUrl: "",
  instagramUrl: "",
  whatsappUrl: "",
  youtubeUrl: "",
  telegramUrl: "",
};
